import { API, IS_DEV } from '../../../shared/constants';
import { apiClient } from '../../../shared/lib/apiClient';
import { getConnectionScreenDevUrl } from '../../../shared/lib/dev';
import { Order, VendingMachine } from '../../../shared/types';
import { OrderDto, toOrder } from '../lib/to-order';

export const ORDER_QUERY_KEYS = {
    all: () => ['order'] as const,
    receiptPoll: (id: string | null) => [...ORDER_QUERY_KEYS.all(), 'receipt-poll', id] as const,
};

export const checkQrData = async (qr: string): Promise<VendingMachine> => {
    const url = `${API.CHECK_QR}?qr=${qr}`;
    const { data } = await apiClient.get<VendingMachine>(url);
    return data;
};

export const checkQrServiceData = async (qr: string): Promise<VendingMachine> => {
    const url = IS_DEV
        ? `/dev/qr.json?qr=${qr}&service=1}`
        : `/api/check?qr=${qr}`;
    const { data } = await apiClient.get<VendingMachine>(url);
    return data;
};

export const connectToVendingMachine = async (
    qr: string,
    nfc: boolean,
    timerTime?: number,
): Promise<Order> => {
    const url = IS_DEV && timerTime !== undefined
        ? getConnectionScreenDevUrl(timerTime)
        : `${API.CONNECT}?qr=${qr}${nfc ? '&src=nfc' : ''}`;
    const { data } = await apiClient.get<OrderDto>(url);
    return toOrder(data);
};

export const getOrderInfo = async (
    orderId: string,
    timerTime?: number,
): Promise<Order> => {
    const url = IS_DEV && timerTime !== undefined
        ? getConnectionScreenDevUrl(timerTime)
        : `${API.ORDER}?id=${orderId}`;
    const { data } = await apiClient.get<OrderDto>(url);
    return toOrder(data);
};

export const cancelOrder = async (orderId: string): Promise<void> => {
    await apiClient.get(`${API.CANCEL}?id=${orderId}`);
};
